// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"color-box_wrapper__IJdrc","colorBox":"color-box_colorBox__funhq","form":"color-box_form__2Mt6o","input":"color-box_input__pFTpm"};